module.exports = __webpack_public_path__ + "img/服务.792ea527.png";